import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from '../reducers';
import statusTransform from '../transforms/statusTransform';
import authTransform from '../transforms/authTransform';

const rootPersistConfig = {
  key: 'root',
  storage,
  // `ui` is measured from the window on every load, so persisting it is not
  // just redundant — a stored slice from an older build rehydrates over the
  // initial state and reintroduces whatever keys it was missing as undefined.
  // `fleet` holds class instances and must be fresh: see fleetReducer.
  blacklist: ['alerts', 'ui', 'fleet'],
  transforms: [statusTransform, authTransform]
};

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);
export const store = createStore(
  persistedReducer
);
export const persistor = persistStore(store);
